import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Input from '@welldev-group/rcl-input';
import Button from '@welldev-group/rcl-button';
import Modal from '@welldev-group/rcl-modal';
import Icon from '@welldev-group/rcl-icon';
import { I18nText } from '@welldev-group/react-comp-lib';
import Alert from '@welldev-group/rcl-alert';

const WorkSpaceModal = props => {
  const {
    title,
    action,
    fetchWorkspaces,
    openConfirmationModalOfCreatingWorkspace,
    subheaderText,
    workspaceId,
    workspaceName,
    setWorkspaceName,
    workspaceIdentifier,
    setWorkspaceIdentifier,
    disableIdentifierField,
    buttonText,
    isVisible,
    onModalClose,
  } = props;

  const [error, setError] = useState({});
  const onWorkspaceButtonClickHandlerAction = () => {
    action(workspaceId)
      .then(response => {
        if (response.error === null) {
          openConfirmationModalOfCreatingWorkspace();
          onModalClose();
          fetchWorkspaces();
        }
      })
      .catch(({ response }) => {
        if (response && response.status === 422) {
          setError(response.data.error);
        }
      });
  };

  const onInputChangeHandler = (inputValue, setState, errorKeyName) => {
    setState(inputValue);

    if (inputValue) {
      setError({ ...error, [errorKeyName]: null });
    }
  };

  const createButtonDisabled =
    workspaceName.trim().length === 0 &&
    workspaceIdentifier.trim().length === 0;

  return (
    <Modal
      className="workspace-create__modal"
      isVisible={isVisible}
      onOutsideClick={onModalClose}
    >
      <div className="user-modal__edit-header">
        <Modal.Title>{title}</Modal.Title>
        <div
          onClick={onModalClose}
          onKeyDown={onModalClose}
          role="presentation"
        >
          <Icon name="close" size="normal" />
        </div>
      </div>

      <div>
        <Modal.Content>
          <div className="workspace-create__message">{subheaderText}</div>
          <div>
            <Input
              onChange={value =>
                onInputChangeHandler(value, setWorkspaceName, 'name')
              }
              placeholder={I18n.t('components.workspace.placeholder.name')}
              error={error.name}
              touched={!!error.name}
              value={workspaceName}
            />
          </div>
          <div>
            <Input
              onChange={value =>
                onInputChangeHandler(
                  value,
                  setWorkspaceIdentifier,
                  'identifier',
                )
              }
              placeholder={I18n.t(
                'components.workspace.placeholder.identifier',
              )}
              error={error.identifier}
              touched={!!error.identifier}
              value={workspaceIdentifier}
              disabled={disableIdentifierField}
            />
          </div>
        </Modal.Content>
        <Modal.Footer>
          <div className="col-grid col-bleed direction-row">
            <Button
              label={buttonText}
              version="v2"
              onClick={onWorkspaceButtonClickHandlerAction}
              size="small"
              type="primary"
              disabled={createButtonDisabled}
            />
            <Button
              label={<I18nText id="workspace.button_label.cancel" />}
              onClick={onModalClose}
              version="v2"
              size="small"
            />
          </div>
        </Modal.Footer>
      </div>
      <Alert
        className="workspace-create__modal--alert"
        isVisible={!!error.base}
        hideClose={true}
        type="danger"
      >
        {error.base}
      </Alert>
    </Modal>
  );
};

WorkSpaceModal.defaultProps = {
  workspaceName: '',
  workspaceIdentifier: '',
  disableIdentifierField: false,
};

WorkSpaceModal.propTypes = {
  title: PropTypes.node.isRequired,
  action: PropTypes.func.isRequired,
  fetchWorkspaces: PropTypes.func.isRequired,
  openConfirmationModalOfCreatingWorkspace: PropTypes.func.isRequired,
  subheaderText: PropTypes.string.isRequired,
  workspaceName: PropTypes.string,
  workspaceIdentifier: PropTypes.string,
  disableIdentifierField: PropTypes.bool,
  workspaceId: PropTypes.number.isRequired,
  setWorkspaceName: PropTypes.func.isRequired,
  setWorkspaceIdentifier: PropTypes.func.isRequired,
  buttonText: PropTypes.node.isRequired,
  isVisible: PropTypes.bool.isRequired,
  onModalClose: PropTypes.func.isRequired,
};

export default WorkSpaceModal;
